import { Skeleton } from "@chakra-ui/react";
import { Meeting } from "features/Resources/Meeting/models";
import { SchedulingTableButton } from "../../Button/Scheduling";

interface ScheduleAddOrShowDateProps {
  meeting: Meeting;
}

export default function ScheduledAtColumn({
  meeting,
}: ScheduleAddOrShowDateProps) {
  if (!meeting || !meeting.status) {
    return <Skeleton h="28px" />;
  }

  if (meeting.status === "skipped") {
    return null;
  }
    return <SchedulingTableButton meeting={meeting} />;

}
